import * as tslib_1 from "tslib";
import { Vue, Component, Prop } from "vue-property-decorator";
import { store } from "store";
import axios from "axios";
var EventParticipantTopList = /** @class */ (function (_super) {
    tslib_1.__extends(EventParticipantTopList, _super);
    function EventParticipantTopList() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.loading = true;
        _this.store = store;
        return _this;
    }
    EventParticipantTopList.prototype.created = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this;
                        return [4 /*yield*/, axios.get("sponsors/event-sponsorships/" + this.event.eventId)];
                    case 1:
                        _a.sponsorships = (_b.sent()).data;
                        this.userPosition = this.sponsorships.findIndex(function (s) { return s.userId === store.currentUser.userId; });
                        this.loading = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    tslib_1.__decorate([
        Prop({ default: 10 }),
        tslib_1.__metadata("design:type", Number)
    ], EventParticipantTopList.prototype, "numTop", void 0);
    tslib_1.__decorate([
        Prop(),
        tslib_1.__metadata("design:type", Object)
    ], EventParticipantTopList.prototype, "event", void 0);
    EventParticipantTopList = tslib_1.__decorate([
        Component
    ], EventParticipantTopList);
    return EventParticipantTopList;
}(Vue));
export default EventParticipantTopList;
Vue.component("kk-event-participant-top-list", EventParticipantTopList);



//////////////////
// WEBPACK FOOTER
// ./~/ts-loader!./~/vue-loader/lib/selector.js?type=script&index=0!./app/ts/components/EventParticipantTopList.vue
// module id = 48
// module chunks = 0